// src/scene/IslandConfig.ts
// Island placement configuration — generated by Debug.
// Paste this entire file to replace src/scene/IslandConfig.ts

// ── Positions ─────────────────────────────────────────────────────────────────
export const islandPosition = { x: 0.0000, y: -0.6500, z: -3.3000 };  // raised 0.15 so more of the rock shows above the waterline
export const firecampOffset = { x: 0.0080, y: 1.0000, z: 0.4000 };
export const treeOffset = { x: -0.4500, y: 1.0000, z: -0.3000 };
export const bushOffset = { x: -0.1200, y: 0.8140, z: -0.6690 };
export const bushRadioOffset = { x: -0.8760, y: 0.9270, z: -0.2320 };
export const bushRadio2Offset = { x: -1.2510, y: 0.9270, z: -0.0200 };
export const bushPugOffset   = { x: 1.0390, y: 0.8540, z: -0.0690 };
export const radioOffset    = { x: -0.8470, y: 1.0081, z: 0.2600 };
export const swordOffset    = { x: 0.1550, y: 1.3270, z: 0.1570 };
export const pugOffset      = { x: 0.6500, y: 0.9820, z: 1.0000 };
export const tentOffset     = { x: 0.4800, y: 0.9800, z: -0.3500 };
export const dogBedOffset      = { x: 0.0000, y: 0.8000, z: 3.3000 };
export const phoneOffset       = { x: 0.5000, y: 1.1180, z: -0.6800 };
export const apple1Offset      = { x: -0.7090, y: 2.5500, z: 0.4180 };
export const apple2Offset      = { x: -0.1540, y: 2.6760, z: 0.2710 };
export const apple3Offset      = { x: -0.4780, y: 3.2500, z: 0.1620 };
export const mossRock1Offset   = { x: 0.0000, y: 0.0650, z: -2.2700 };
export const mossRock2aOffset  = { x: -1.0700, y: 0.4000, z: -2.1500 };
export const mossRock2bOffset  = { x: 0.5500, y: 0.4000, z: -2.1500 };
export const mossRock3aOffset  = { x: -1.3350, y: 0.6650, z: 0.7200 };
export const mossRock3bOffset  = { x: -0.5500, y: 0.2750, z: 1.0000 };
export const mossRock3cOffset  = { x: 0.1870, y: 0.7130, z: 1.4420 };
export const foldingTrayTableOffset = { x: 0.6870, y: 0.9800, z: -0.5800 };
export const tentDogBedOffset       = { x: 0.3100, y: 1.0800, z: -0.3000 };
export const rugRoundOffset         = { x: 0.5800, y: 1.0110, z: -0.3500 };
export const lanternOffset          = { x: 0.3500, y: 1.1000, z: -0.6900 };
export const dogBowlOffset          = { x: 0.7000, y: 1.0810, z: -0.3200 };
export const dogBiscuitOffset       = { x: 0.6300, y: 1.1900, z: -0.2200 };
// Nailed to the tree trunk, a little above the radio: the radio sits at y=1.0000
// with a 0.22 scale, so its top is around y=1.22 in this offset space.
export const noticeBoardOffset      = { x: -0.4450, y: 1.7590, z: -0.0400 };
// Hung on the trunk just above the board. picture_frame.glb is authored facing
// +X (its node carries a 90° X-rotation and a 100× scale), so it needs a
// roughly -90° yaw to turn the photo toward the camera — the few degrees off
// square are deliberate, it reads as hung by hand rather than mounted.
export const pictureFrameOffset     = { x: -0.4450, y: 2.0700, z: -0.0400 };

// ── Scales ────────────────────────────────────────────────────────────────────
export const islandScale      = 0.2500;
export const firecampScale    = 1.4000;
export const treeScale    = 0.4330;
export const bushScale    = 0.3500;
export const bushRadioScale = 0.3650;
export const bushRadio2Scale = 0.2950;
export const bushPugScale   = 0.3000;
export const radioScale       = 0.2200;
export const swordScale       = 0.2500;
export const pugScale         = 0.4500;
export const tentScale        = 0.0750;
export const dogBedScale      = 1.0000;
export const phoneScale       = 0.1500;
export const apple1Scale      = 0.0100;
export const apple2Scale      = 0.0100;
export const apple3Scale      = 0.0100;
export const mossRock1Scale   = 0.6290;
export const mossRock2aScale  = 0.6290;
export const mossRock2bScale  = 0.5140;
export const mossRock3aScale  = 2.4740;
export const mossRock3bScale  = 3.3970;
export const mossRock3cScale  = 2.1050;
export const foldingTrayTableScale = 0.0110;
export const tentDogBedScale       = 0.1600;
export const rugRoundScale         = 0.3500;
export const lanternScale          = 0.3000;
export const dogBowlScale          = 0.0400;
export const dogBiscuitScale       = 3.5810;
// The board's plank panel is BOARD_W (1.0) in local units, so this IS its world
// width.
export const noticeBoardScale      = 0.3950;
export const pictureFrameScale     = 0.1500;

// ── Rotations ─────────────────────────────────────────────────────────────────
export const treeRotY   = 0.0000;
export const bushRotY   = 2.2300;
export const bushRadioRotY = 1.2000;
export const bushRadio2RotY = 0.0664;
export const bushPugRotY   = -0.6500;
export const radioRotY      = 0.4954;
export const swordRot       = { x: 2.6364, y: 0.0834, z: 0.1664 };
export const pugRotY        = -0.4536;
export const tentRotY       = -0.4000;
export const dogBedRotY     = 0.0000;
export const phoneRot       = { x: -0.8676, y: -0.0306, z: -0.0096 };
export const apple1RotY     = 0.1764;
export const apple2RotY     = -0.9226;
export const apple3RotY     = -0.5000;
export const mossRock1Rot   = { x: 0.0000,  y: 0.6494,  z: 0.0000 };
export const mossRock2aRot  = { x: 0.0000, y: 1.8664, z: 0.0000 };
export const mossRock2bRot  = { x: 0.0000, y: -3.1416, z: 0.0000 };
export const mossRock3aRot  = { x: 0.5914, y: 2.6204, z: 0.0000 };
export const mossRock3bRot  = { x: 0.4174, y: -3.1416, z: 0.0000 };
export const mossRock3cRot  = { x: 0.3594, y: -2.5966, z: 0.1274 };
export const foldingTrayTableRot = { x: 1.5764, y: -0.1046, z: 0.3014 };
export const tentDogBedRot       = { x: 0.0000,       y: 1.9244,       z: 0.0000 };
export const rugRoundRot         = { x: 0.0000,         y: 0.0000,         z: 0.0000 };
export const lanternRot          = { x: 0.0000,          y: 1.5184,          z: 0.0000 };
export const dogBowlRot          = { x: 0.0000,          y: 0.0000,          z: 0.0000 };
export const dogBiscuitRot       = { x: 0.0000,       y: 0.0000,       z: 0.0000 };
// 0 = the notice faces +Z, straight at the default camera.
export const noticeBoardRotY     = -0.0006;
export const pictureFrameRotY    = -1.4136;

// ── Island surface grass filter ──────────────────────────────────────────────
export const ISLAND_SURFACE_GRASS_COLOR = '#293c00'; // sRGB hex
export const ISLAND_SURFACE_GRASS_STRENGTH = 1.0000; // 0 = original texture, 1 = full tint
export const ISLAND_SURFACE_GRASS_GREEN_THRESHOLD = 0.0400; // green dominance needed for mask
export const ISLAND_SURFACE_GRASS_NORMAL_THRESHOLD = 0.8100; // upward-facing normal needed
export const ISLAND_SURFACE_GRASS_MASK_SOFTNESS = 0.2710; // feather for color/normal mask
export const ISLAND_SURFACE_GRASS_TOP_FILL_STRENGTH = 0.3500; // fills upward top faces that miss the color mask
export const ISLAND_SURFACE_GRASS_TOP_FILL_NORMAL_THRESHOLD = 0.5700; // lower upward-facing normal cutoff for top fill
export const ISLAND_SURFACE_POINT_LIGHT_INFLUENCE = 0.4500; // lowers fire point-light faceting on island only
export const ISLAND_CAMPFIRE_GROUND_COLOR = '#6b3f20'; // sRGB hex
export const ISLAND_CAMPFIRE_GROUND_RADIUS = 0.6300;
export const ISLAND_CAMPFIRE_GROUND_SOFTNESS = 0.4510;
export const ISLAND_CAMPFIRE_GROUND_STRENGTH = 1.0000;
export const ISLAND_CAMPFIRE_GROUND_NORMAL_THRESHOLD = 0.6000; // upward-facing normal needed for ground tint

// ── Island rock-match color grade ─────────────────────────────────────────────
export const ISLAND_ROCK_MATCH_COLOR = '#006080'; // sRGB hex — target rock tint
export const ISLAND_ROCK_MATCH_STRENGTH = 1.0000; // overall blend on rock areas (0 = off)
export const ISLAND_ROCK_MATCH_SATURATION = 0.4500; // 1 = keep original saturation, 0 = grayscale
export const ISLAND_ROCK_MATCH_BRIGHTNESS = 0.8000; // 1 = keep, >1 lifts the dark underside
export const ISLAND_ROCK_MATCH_COLOR_TINT = 0.5500; // how much the target color tints (0..1)
export const ISLAND_ROCK_MATCH_GREEN_THRESHOLD = -0.0150; // green dominance to treat a pixel as moss
export const ISLAND_ROCK_MATCH_GREEN_STRENGTH = 0.7100; // tint applied to underside moss (protected from gray)
export const ISLAND_ROCK_MATCH_GREEN_COLOR = '#862d2d'; // sRGB hex — underside moss tint (matches surface grass)

// ── Bush flower colors ───────────────────────────────────────────────────────
export const bushFlowerColor      = '#f2d34f';
export const bushRadioFlowerColor = '#f2d34f';
export const bushRadio2FlowerColor = '#f2d34f';
export const bushPugFlowerColor   = '#f2d34f';

// ── Apple wind sway ───────────────────────────────────────────────────────────────
export const APPLE_WIND_STRENGTH   = 0.1700;  // TWEAK: Background sway amplitude (0 = off, 0.3 = strong)
export const APPLE_SWING_STIFFNESS = 18.0;    // TWEAK: Spring K (rad/s²) — higher = faster oscillation
export const APPLE_SWING_DAMPING   = 4.5;     // TWEAK: Damping D — higher = settles faster
export const APPLE_CLICK_IMPULSE   = 4.5;     // TWEAK: Angular velocity kick on click (rad/s)
export const APPLE_RESPAWN_FADE_DURATION = 1.5;
export const APPLE_CLICK_COUNT_TO_FALL  = 3;
export const MAX_GROUND_APPLES          = 6;
export const APPLE_RESPAWN_DELAY        = 0.8;  // TWEAK: Seconds after landing before tree apple respawns

// ── Golden apple easter egg ─────────────────────────────────────────────────────
export const GOLDEN_APPLE_INTERVAL      = 3;
export const GOLDEN_APPLE_COLOR         = '#c8a820';
export const GOLDEN_APPLE_EMISSIVE      = '#e2b512';
export const GOLDEN_APPLE_EMISSIVE_INTENSITY = 1.15;
export const GOLDEN_APPLE_COLOR_Y_CUTOFF    = 0.75;
export const GOLDEN_APPLE_LIGHT_COLOR       = '#d0ba62';
export const GOLDEN_APPLE_LIGHT_INTENSITY   = 0.45;
export const GOLDEN_APPLE_LIGHT_DISTANCE    = 1.00;
export const GOLDEN_APPLE_LIGHT_DECAY       = 2.00;

// ── Foliage ────────────────────────────────────────────────────────────
export const GRASS_COUNT          = 204;
export const GRASS_Y_OFFSET        = 0.0000;
export const GRASS_COLOR_BASE      = '#3e7330'; // sRGB hex — reads as an extension of the island floor
export const GRASS_COLOR_TIP       = '#427335';  // sRGB hex — barely lighter than base, just enough to keep tip shading readable
export const FOLIAGE_WIND_STRENGTH = 0.0350;
export const GRASS_WOBBLE_STRENGTH  = 0.034;  // constant base sway
export const GRASS_MAX_HEIGHT       = 0.055;  // max blade height
export const GRASS_EDGE_FALLOFF_RADIUS = 0.05;   // probe radius for edge blade taper
export const GRASS_MIN_EDGE_SCALE      = 0.21;   // minimum blade scale at island edge (0–1)
export const GRASS_SHADOW_OPACITY      = 0.00;   // alpha of dark AO floor under grass
export const GRASS_SHADOW_COLOR        = '#0d1a05'; // sRGB dark green-black
export const GRASS_SHADOW_Y_OFFSET     = 0.009;  // Y below average surface (negative = lower than blades)
export const GRASS_SHADOW_SPREAD       = 1.04;   // disc radius scale (1.0 = cluster width)

// ── Spawn edge padding ────────────────────────────────────────────────────────
export const SURFACE_EDGE_PADDING = 0.200;

// ── Exclusion zone radii (grass spawn clearance around each surface object) ───
export const EXCL_R_BONFIRE = 0.42;
export const EXCL_R_TENT    = 0.73;   // custom tent — increase to push grass further out
export const EXCL_R_TREE    = 0.14;
export const EXCL_R_RADIO   = 0.26;

// ── Fire light ───────────────────────────────────────────────────────────────────
export const FIRE_LIGHT_INTENSITY = 2.60;   // Base intensity multiplier (before flicker)
export const FIRE_LIGHT_RANGE     = 1.50;   // PointLight max range in world units
export const FIRE_LIGHT_DECAY     = 2.0;   // Light falloff (2 = physically based)
export const FIRE_LIGHT_FLICKER   = 0.30;   // 0 = steady, 1 = heavy flicker

// ── Notice board ──────────────────────────────────────────────────────────────
// Optional GLB to use instead of the procedural board built by NoticeBoard.ts.
// Path is relative to public/ (e.g. 'models/surface/notice_board.glb'). Leave
// null to keep the procedural one — a non-null path that 404s falls back to it.
export const noticeBoardModelPath: string | null = null;
// Zoom framing. The camera stands `dist` out along the board's facing normal, so
// these are read the same way as the radio zoom.
export const noticeBoardZoomDist      = 1.2500;
export const noticeBoardZoomHeight    = 0.0500;
export const noticeBoardZoomFov       = 25.5000;
export const noticeBoardZoomMobileFov = 45.0000;
export const noticeBoardZoomPitch     = 0.0000;

// ── Phone ─────────────────────────────────────────────────────────────────────
export const phoneZoomHeight = 0.0500;
export const phoneZoomTilt   = 0.4300;
export const phoneZoomPitch  = -0.1000;
export const phoneZoomFov    = 20;
export const phoneScreenWidth   = 0.0550;
export const phoneScreenHeight  = 0.1020;
export const phoneScreenOffsetX = 0.0000;
export const phoneScreenOffsetY = 0.0020;
export const phoneScreenOffsetZ = 0.0110;
export const phoneOverlayOpacity      = 0.3970;
export const phoneOverlayTintR        = 180;
export const phoneOverlayTintG        = 200;
export const phoneOverlayTintB        = 255;
export const phoneOverlayGlareOpacity = 0.3100;
export const phoneOverlayGlareAngle   = 237;